module.exports = __webpack_public_path__ + "static/media/Flutter.adbdc925.png";